import { Configuration, Id } from '@ess/jg-rule-executor';
import { PortalConfigurationPlacement } from '@src/app/model/portal-configuration-placement';

export class PortalConfiguration extends Configuration {
  constructor(
    id: Id<Configuration>,
    name: string,
    email: string,
    code: string,
    configurationPlacement: PortalConfigurationPlacement,
    isPreConfiguration: boolean,
  ) {
    super(id, name, email, code, configurationPlacement, isPreConfiguration, undefined, undefined, undefined, false);
  }
}
